/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import { memo } from 'react';

import { useSelector } from 'react-redux';

import { tableTranslationNoValueSelector } from '../../selectors';
import TableCellNoValueStyled from './styled/TableCellNoValueStyled';

const TableCellNoValue = () => {

    const noValue = useSelector(tableTranslationNoValueSelector);

    return (
        <TableCellNoValueStyled>
            {noValue}
        </TableCellNoValueStyled>
    );
};

export default memo(TableCellNoValue);
